import { render, staticRenderFns } from "./OrderReportList.vue?vue&type=template&id=54550e2c"
import script from "./OrderReportList.vue?vue&type=script&lang=ts"
export * from "./OrderReportList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports